import React, {useState, useEffect, useCallback, useContext, useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import ItemUserProfle from '../ItemUserProfile';
import Button from '@components/Button';
import Spinner from '@components/Spinner';
import Loading from '@components/Loading';
import actions from '@state/actions';
import { openNewTemplateAction, reloadListAction } from '@state/openReducers/actions';
import { setParams } from '@utils/userUtils';
import selectors from '@state/selectors';
import { IndexesActions, IProps } from './types';
import * as S from './styles';
import _ from "lodash";
import { fetchIndustries } from '@state/industries/utils';
import { getBrandIdByOEMName } from 'utils/editor';
import MouseSelection from '@components/MouseSelection';
import { boxesIntersect, SelectionBox } from 'react-drag-to-select';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { IUserType } from '@state/auth/types';
import { UserAccessContext } from '@utils/DOIgnition/UserAccessContex';
import EmptyDesignIcon from '@assets/icons/emptyDesignIcon';
import Menu from '../Menu';
import { ICoordinates } from '../ItemUserProfile/types';
import DeleteUserProfile from '../Delete';
import { IUserAccess } from '@state/userAccess/types';
import { DEFAULT_USER_FILTER, getAllBrands } from '@utils/userAccess';

const List:React.FC<IProps> = ({filters, activeFilter, orderBy, onActionsTemplate, deteleItem, editUser, savedItems, gridView,deleteTemplates, handleWarningScreen}) => {
  const dsConfig = useSelector(selectors.dsConfig.getDSConfig);
  const{ searching, value, setSearchQuery, 
         userAccessDetail, setUserAccessDetail, 
         fetchCounter, setFilterQuery, filtering, forceSearch,
         getQuerySearchFilters, hasDesigns, sortByText, showCounter,
         setSearching, setShowList} = useContext(UserAccessContext);

  const authContext = React.useContext(AuthContext);
  const isAdmin = authContext.userData && authContext.userData.profile && authContext.userData.profile.role === IUserType.ADMIN;
  const userData = authContext && authContext.userData?authContext.userData.profile:undefined;
  

  const [initial, setInitial]=useState(true);
  const [reload, setReload]=useState(false);
  const [title, setTitle]=useState("Loading user profiles...")
  const [filter, setFilter]=useState({} as any);
  const [start, setStart]=useState(0)
  const [page, setPage]=useState(20)
  const [hasMore, setHasmore]=useState(true)
  const [show, setShow]=useState(false);
  const [spinner, setSpinner]=useState(true);
  const [loading, setLoading]=useState(false);
  const [orderPublished, setOrderPublished]=useState('')
  const [selectedIndexes, setSelectedIndexes] = useState<number[]>([]);
  const [allowClean, setAllowClean] = useState<boolean>(true);
  const [openOptions, setOpenOptions] = useState(false);
  const [coordinates, setCoordinates] = useState({x: 0, y: 0});  

  const [itemMenu, setItemMenu] = useState<IUserAccess>();
  const [coordinatesMenu, setCoordinatesMenu] = useState({x: 0, y: 0});  
  const [deleteUser, setDeleteUser]=useState<IUserAccess|undefined>();

  const [items, setItems]=useState([]);
  const [message, setMessage]=useState('');
  const [count, setCount]=useState(0);

  const dispatch = useDispatch();
  const history = useHistory();

  const refTop = useRef<HTMLDivElement>(null);
  const scrollDiv = useRef<HTMLDivElement>(null);
  const stateRef = useRef<boolean>();
  const selectedRefs = React.useRef<(HTMLDivElement | null)[]>([]);

  const userprofiles = useSelector(selectors.userAccess.getUserAccess);
//  const newTemplate = useSelector(selectors.open.getOpenTemplate);
  const reloadList = useSelector(selectors.open.getReloadList);
  const postedUserAccess = useSelector(selectors.userAccess.getPostedUserAccess)
  const industriesOptions = useSelector(selectors.industries.getIndustries)
//  const counter = useSelector(selectors.templates.getTemplateCounter);
  
  const fetchUserProfiles = (restart:boolean=false) => {
    
    if(userprofiles && userprofiles.length==0)setSpinner(true);
    
    let query=createQuery(restart);            
    return new Promise((resolve, reject) => {
      dispatch(actions.userAccess.fetchUserAccess(query,(result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  }

  const createQuery=(restart:boolean)=>{
    let filtersQuery=``;
    let addOr=false;
    let startQuery=0;
    if(!restart){
      startQuery=start;
      setStart(start+page);
    }else{
      setUserAccessDetail([]);
      setStart(page);
      setSpinner(true);
    }

    if(filter){
      Object.keys(filter).forEach((key) => {          
          if (filter[key].length>0){            
            let columQuery='';
            let item=filter[key];
            if (key =='oem')
            {
              item.forEach((text:string, idx:number) => {
                if (text=="Access to all")
                  columQuery += (columQuery==''?'':' or ') + `c.hasAllAccess = true`;
                else  
                  columQuery += (columQuery==''?'':' or ') + `ARRAY_CONTAINS(c.brands,'${getBrandIdByOEMName(text, dsConfig)}')`;
                
              });
              if (columQuery!=='')
                columQuery=`(${columQuery})`
            }

       
            filtersQuery=filtersQuery+columQuery
            if(filtering)setFilterQuery(filtersQuery);
            addOr=true;
          }

          //if (key ==="format" && filter[key] && filter[key].name) {
          //  filtersQuery = filtersQuery + ` and udf.searchFormat(c.tags.formats, '${filter[key].name}', c.templateStatus) `;
          //}
      });
    }

    let searchQuery =''
    if (searching)
      searchQuery = `(c.user.email LIKE "%${value.toLowerCase()}%" or LOWER(c.user.name) LIKE  "%${value.toLowerCase()}%" or ARRAY_CONTAINS("${value.toLowerCase()}", c.clientIds, true)) `;   

    if (filtersQuery!=='')
      searchQuery+= (searchQuery==''?'':' and ') + `${filtersQuery}`

    searchQuery = encodeURIComponent(searchQuery);
    return `?filter=${searchQuery}&userdata=${JSON.stringify(userData)}&orderby=${orderBy !== '' ? orderBy : DEFAULT_USER_FILTER}&start=${startQuery}&pagelength=${page}`;
  }

  const handleOpenNewTemplate = () => {
    dispatch(reloadListAction(false));
    dispatch(openNewTemplateAction(true));
    const url = setParams({ page: "new-template" });
    history.push(`?${url}`);
  }

  useEffect(() => {
      setTimeout(function() {
        const run = async () => {          
          await fetchUserProfiles(false);
          setTitle("No user profiles added")
        }
        run();
      }, 200);    
  }, [])

  useEffect(() => {        
    if(userprofiles){       
      

      if(userprofiles.length>0){
        var newUserProfiles = userAccessDetail;
        //var newUserProfiles: any[] = [];

        /*if((userAccessDetail.length>0)&&(!reload)){        
          //if(start>20 || orderPublished==="UNPUBLISHED")newUserProfiles=userAccessDetail;
          if(start>20)newUserProfiles=userAccessDetail;
        }
        else {
          setReload(false);
          if (refTop && refTop.current){
            refTop.current.scrollIntoView({ behavior: 'smooth', block: 'nearest'})
          }                    
        }*/


        for (var i = 0; i < userprofiles.length; i++) {
          newUserProfiles.push(userprofiles[i])          
        }
        setUserAccessDetail([...newUserProfiles])                
      }


      if(userprofiles.length<20){     
          setHasmore(false);
          //if(start==20 && userprofiles.length===0){
          //  setUserAccessDetail([] as any);
          //}
        //}
      }
      else{
        setHasmore(true);
        //if(start>0)setSpinner(false);
      }
      setLoading(false);
      setSpinner(false);
    }
  }, [userprofiles])

  const debounce = useCallback(
    _.debounce((_searchVal: any) => {
      setFilter(_searchVal);
    }, 500),
    []
  );
  useEffect(() => debounce(filters), [filters]);

  useEffect(() => {
    if(activeFilter){
      setOrderPublished('');
      if (refTop && refTop.current){
        refTop.current.scrollIntoView({ behavior: 'smooth', block: 'nearest'})
      }
      setReload(true);
      const run = async () => {
        await fetchUserProfiles(true);
        setTitle("No user profiles added")
      }
      run();
    }
  }, [filter])

  useEffect(() => {
    if(orderBy!==""){
      setOrderPublished('');
      if (refTop && refTop.current){
        refTop.current.scrollIntoView({ behavior: 'smooth', block: 'nearest'})
      }
      const run = async () => {
        await fetchUserProfiles(true);
      }
      run();
    }
  }, [orderBy])

  useEffect(() => {    
      if(reloadList){        
        setReload(true);    
        fetchUserProfiles(true);            
        dispatch(reloadListAction(false));
      }
  }, [reloadList])

  const handleSelectedIndexes = (index: number, action: IndexesActions) => {
    if (action === 'ADD') {
      setSelectedIndexes([...selectedIndexes, index]);
    } else if (action === 'REMOVE') {
      setSelectedIndexes([...selectedIndexes.filter(selectedIndex => selectedIndex !== index)]);
    }
  }

  const handleOpenMenu = (item:any, coordinates:ICoordinates)=>{
    let scrollTop = scrollDiv.current?.scrollTop??0;   
    let clientHeight = scrollDiv.current?.clientHeight??0;
    let clientWidth = scrollDiv.current?.clientWidth??0;
    let posX = coordinates.x - 45
    let diffX = coordinates.x-clientWidth;
    if (diffX<200)
      posX+= 290;    
    let diff = clientHeight-coordinates.y;
    let posY = coordinates.y + scrollTop;
    if (diff <100)
      posY = posY + diff -150                    
    setCoordinatesMenu({x: posX, y: posY})
    setItemMenu(item);
  }
  

  const fillItems = ()=>{
    let newItems = userAccessDetail.map((userItem: IUserAccess, idx:number)=>{          
      const item = getAllBrands(dsConfig, {...userItem}, industriesOptions)
      return  <CSSTransition key={item.id} timeout={700} classNames="item">
                <ItemUserProfle
                  idx={idx}
                  item={item}
                  onActionsTemplate={onActionsTemplate}
                  selected={selectedIndexes.includes(idx)}
                  //setOpen={setOpenOptions}
                  setOpen={(e:any)=>{}}
                  handleMenu={handleOpenMenu}
                  handleSelectedIndexes={handleSelectedIndexes}
                />
              </CSSTransition>        
    });

    
    if (newItems.length==0)
      setMessage("There are no user profiles with those filters.")
    else
    {
      setCount(0)
      setMessage('')
    }
    

    setItems(newItems);    

  }

 

  //let minHeight='';
  //if(items && items.length<9)minHeight='100%';

  let top='114px';
  //if(location==='studio' && !hasDesigns && filtering)top='390px';
  //if(searching)top='186px';
  
  const handleClickOutside = (e: any)=> {
    if(selectedRefs && selectedRefs.current){
        const ref: (HTMLDivElement | null)[] = selectedRefs.current;
        let found = false;
        if (ref) {
          ref.forEach(refDesign => {
            if (refDesign?.contains(e.target)) found= true;
          });
          setTimeout(() => {
            if (!found && stateRef.current) {
              if (!e.shiftKey){
                setSelectedIndexes([]);
                setOpenOptions(false);
                setItemMenu(undefined)
              }
            }
          }, 100)
        }
    }
  }

  const handleSelectionStart = useCallback(
    () => {
      setAllowClean(false);
    },
    []
  );

  const handleSelectionChange = useCallback((box) => {
  }, []);

  const handleSelectionEnd = useCallback(
    (box: SelectionBox) => {
      let indexesToSelect: number[] = [];
      const elementsContainer = document.getElementById("template-list");
      if (elementsContainer) {
        Array.from(elementsContainer.childNodes).forEach((item, index) => {
          try{
          const boundingBox = (item as Element).getBoundingClientRect();
          if (boxesIntersect(box, boundingBox)) {
            indexesToSelect.push(index);
          }
        }catch{
          console.log("Error on src/routes/private/UserManagement/components/ListUserAccess/components/List/index.tsx line 356")
        }
        });
      }
      setSelectedIndexes(indexesToSelect);
    },
    []
  );

  const handleSetCoordinates = (e: React.MouseEvent<HTMLDivElement>) => {
    if (openOptions === false)    
    {
      let scrollTop = scrollDiv.current?.scrollTop??0;
      setCoordinates({x: e.clientX - 180, y: e.clientY-200 + scrollTop});    
    }
  }


  const handleMenuActions = (item: IUserAccess, action: string)=>{
    if (action === "EDIT") {
      const newItem = userAccessDetail.find((userAccess: IUserAccess) => userAccess.id === item.id)
      if (newItem) editUser(newItem)
    }
    if (action=="DELETE")
      setDeleteUser(item)    
  }


  const onActions = (item: any, action: string) => {    
    if (action==="DELETEUSER"){       
      setDeleteUser(undefined);
      const newUserAccessDetail = userAccessDetail.filter( (profile:any) =>{              
        return profile.id !== item.id
      })      
      setUserAccessDetail(newUserAccessDetail);
    };    
    if (action==="CANCELDELETEUSER")
    { 
      setDeleteUser(undefined);
      //deleteBrandRequest()
      //setDeleteBrand(undefined)
    };
  }

  const handleScroll = async(e: any) => {
    
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    
      if (bottom && hasMore)
      {
        setLoading(true)
        fetchUserProfiles(false)                
      }
  }

  const bringIndustries = async () => {
    if (!industriesOptions.length) {
      await fetchIndustries(dispatch)
    }
  }

  useEffect(() => {
    if (stateRef) stateRef.current = allowClean;
  }, [allowClean]);

  useEffect(() => {
    bringIndustries()
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(()=>{
    fillItems()
  },[userAccessDetail])
  return (
    <>
    <S.Root
      id="scrollableDiv"      
      top={top}
      onMouseMove={handleSetCoordinates}
      ref={scrollDiv}
      onScroll={handleScroll}       
    >
      <S.Container onMouseDown={() => setAllowClean(true)} >
        <MouseSelection
          onSelectionChange={handleSelectionChange}
          onSelectionEnd={handleSelectionEnd}
          onSelectionStart={handleSelectionStart}
        />
        <div  ref={refTop}/>
        {spinner && <Spinner/>}                      
        {!show && !spinner &&
        <>                    
              <S.TypeContainer id={gridView?'gridList':'itemsList'}>
                <TransitionGroup className="group-list" id="template-list">
                  {
                    sortByText &&
                    <S.OrderByLabel>
                      Sorted: {sortByText}
                    </S.OrderByLabel>
                  }
                  {items}
                </TransitionGroup>
              </S.TypeContainer>                       
              {loading&& <Loading 
                id={"loading-designs"}
                pointsColor='#f66000' 
                containerStyle={{justifyContent: 'center'}}
              />}
              {
                 <S.Text style={spinner?{display:"none"}:{}}> {message} </S.Text>
              }
      </>      
        }

{
      itemMenu &&
      <Menu
        open={itemMenu?true:false}
        setOpen={setOpenOptions}
        coordinates={coordinatesMenu}
        item={itemMenu}           
        onActions={handleMenuActions}
        >          
      </Menu>     
    }      
    {
      deleteUser &&
      <DeleteUserProfile
        open={true}
        isSaving={false}
        onActions={onActions}
        item={deleteUser}
      >
      </DeleteUserProfile>
    }
      
        
        {show  &&

            <S.TabNoDesignsContainer>
                    <S.EmptyIcon>
                      <S.EmptyIconScale>
                        <EmptyDesignIcon/>
                      </S.EmptyIconScale>
                    </S.EmptyIcon>
                    <S.EmptyTextContainer>
                      <S.EmptyTitle>
                        No users added yet
                      </S.EmptyTitle>
                      <S.TabEmptySubtitle>
                      Add users by email, and set their permissions for the OEMs that are available to them as Templates and in the Brand Library
                      </S.TabEmptySubtitle>
                      <Button
                        icon="add" 
                        label="ADD USER"
                        style={{hoverBackgroundColor: "#344a70", backgroundColor: "#19325d", width: 153, height: 36, boxSizing: 'border-box', marginTop:"20px"}}
                        labelStyle={{color: "white", fontWeight: '500'}}
                        onClick={()=>{}}
                    />   
                    </S.EmptyTextContainer>
                  </S.TabNoDesignsContainer>



       
        }
      
      </S.Container>
     
    </S.Root >
   
  </>


  );
}

export default List;